var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgCurriculumLandingStairway2 = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "450 0 816 367",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#CDCDCD",
    d: "M450 332.479s28.891 1.166 56.023 1.597l46.477-1.597c-2.19 1.8-23.714 1.957-46.477 1.597L450 336z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#CDCDCD",
    d: "M552.5 332.479c-4.8 3.945-102.5 0-102.5 0V336zm0 0c4.8-3.945-6.72-47.508 0-49.479s115.64-2.239 119-5-3.36-36.705 0-42.234 75.5 0 75.5 0v-42.765c0-8.682 22.976-7.672 41-8.949 16.995-1.204 286.24 2.37 292 0"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#F0BE91",
    d: "M879 110.328c-5.232 3.417-9.87-1.211-16 0-1.58.312-3 1.5-3 1.5l-3-1.5s-3.145.277-5 1c-3.99 1.555-3.832 8.484-8 7.5-4.094-.966-4-10-4-10l-7 3.5s1.6 15.287 8.5 15.5c5.398.167 10.5-9 10.5-9l-1 14.5 17.5 1.5-1.5-16s10.981.526 16.5-3c3.963-2.532 8-9 8-9l-6.5-4.5s-2.73 5.865-6 8"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#F4D4B8",
    d: "m834 100.328-1 6v2.001l1.5 3.499 4-2v-.5l1.5-2.499-1-1.5-2-.001 1.5-4.499s-1-2.5-1.5-.501-2 5-2 5 .5-3.5.5-5-1.5 0-1.5 0m53 .5-.5 2.5 4 3.002s1.267-2.357 2-3.001c1.392-1.223 2.221-.161 3.5-1.501 1.888-1.977.731-4.06-.5-6.5-.563-1.116-2.799-1.15-4-1.499-1.186-.345-3.797.49-4.5 1.505-.667.963-.256 4.351 0 5.494"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFF8F8",
    stroke: "#7C6063",
    d: "m821 144.328 4 3.5s-2.777 7.858-4 5.5c-.629-1.213 0-3.5 0-3.5s-2.628 3.733-5 3.5c-1.304-.128-3-1.5-3-1.5z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    stroke: "#7C6063",
    d: "m822 145.828-7.5 7"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFF8F8",
    stroke: "#7C6063",
    d: "m873.659 180.576-2.243-4.819s5.719-6.062 5.884-3.412c.084 1.365-1.416 3.201-1.416 3.201s3.913-2.35 5.988-1.178c1.14.645 2.137 2.586 2.137 2.586z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    stroke: "#7C6063",
    d: "m873.35 178.802 9.691-3.368"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "#94B1EB",
    d: "m845 147.828 6-14.5 17 1.5 8.5 20 3 16-9 5.5-5.5-19.5-7-10.5-12 12.5-25-3 5.5-9.5z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "#F4D4B8",
    d: "m858 110.828.5-2h3.5l.229 2-2.229 2z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fill: "#F4D4B8",
    d: "M865.344 103.112c-.711 3.743-.651 4.165-3.983 6.028-3.369-.313-4.83-.35-6.005-4.265.225-4.192 2.702-6.506 5.583-7.078 1.927.38 4.842 1.32 4.405 5.315"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.5,
    d: "M859.648 106.57c1.013 1.089 2.388.309 3.271-.379z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.5,
    d: "m861.012 105.253 1.486-.295-.654-1.61m.824-.981c-.038-.195.169-.441.383-.637.292-.267.6-.521.952-.342.282.142.374.717.374.717m-6.255 1.165s.041-.467.438-.648c.534-.243.66-.316 1.238-.246.414.051.741.492.741.492m-3.96 4.52s1.831 1.939 4.537 1.624c.547-.064 1.319-.484 1.319-.484"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "evenodd",
    d: "M857.794 95.43c-.773-.688-2.206-.76-3.452-.111-1.431.745-2.074 2.158-1.434 3.156.218.34.557.589.967.739-.343.934-.445 1.934-.256 2.889.097.488.232 1.114.491 1.147.444-.088.713-.226.93-.417l.036-.001s.816 2.194.483 3.752l-.053.26c-.072.37-.137.698-.34 1.063-.399.714-1.74 1.817-1.74 1.817s1.288-.33 1.725-.569c.863-.471 1.096-1.105 1.317-1.959.081-.313.101-.813.101-.813l-.454-2.286c-.068-.343.354-.863.354-.863l.092-2.127.244-.223 3.327-2.481c.382-.2.746-.346 1.072-.41.504-.1.924.276 1.316.627.208.186.407.365.607.462.439.21.824.454 1.153.676q.179.122.335.231l.185.129c.124.243.228.636.249 1.271.057 1.717.202 2.337.202 2.337s.256-.587.443-.964c.16-.32-.193-1.866-.303-2.325.233.031.273-.257.097-1.144a4.75 4.75 0 0 0-.832-1.883c.706-.331 1.216-.878 1.332-1.528.21-1.167-.924-2.227-2.532-2.368-1.497-.131-2.876.58-3.229 1.62a7 7 0 0 0-1.771.124 6 6 0 0 0-.662.171",
    clipRule: "evenodd"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeWidth: 0.5,
    d: "M857 110.33s-.5-.5-5 1-2.5 5.002-6 7-5.5-4.502-5.5-4.502"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M835.749 99.853a.25.25 0 0 0-.498-.046zM835 105.33l-.249-.023.484.108zm3.5-4.5.237.079.023-.069-.017-.071zm-1.5 4.5-.237-.079-.151.453.458-.134zm2 0 .124-.217zm-.5 4-.2-.15-.05.067v.083zm-3.249-9.523-.5 5.5.498.045.5-5.5zM835 105.33l.235.085v-.001l.001-.003.005-.011.016-.046.065-.175a138 138 0 0 1 .973-2.571 57 57 0 0 1 .832-2.03c.128-.291.245-.541.344-.732.105-.204.175-.309.205-.34l-.352-.353c-.095.094-.197.27-.297.463-.106.205-.228.466-.357.761-.26.591-.559 1.329-.84 2.049a138 138 0 0 0-.978 2.58l-.064.176-.017.046-.004.012-.002.003v.001zm2.676-5.823c.024-.023.015-.004-.018-.007-.018-.002-.007-.01.032.03.081.082.175.246.268.461a6 6 0 0 1 .278.82l.016.06.004.015.001.004v.001l.243-.061.243-.061h-.001v-.002l-.001-.005-.005-.018-.017-.065-.066-.226a7 7 0 0 0-.236-.659c-.095-.222-.22-.463-.373-.617a.56.56 0 0 0-.329-.174.47.47 0 0 0-.391.15zm.587 1.244-1.5 4.5.474.158 1.5-4.5zM837 105.33l.07.24h.001l.002-.001.009-.003.04-.01.15-.037c.129-.029.306-.063.503-.086.411-.048.838-.036 1.101.114l.248-.434c-.415-.237-.988-.226-1.407-.177a6 6 0 0 0-.555.095l-.167.041-.047.013-.013.003-.004.001-.001.001zm1.876.217a1.9 1.9 0 0 1 .643.612c.155.241.231.482.231.671h.5c0-.31-.119-.644-.311-.942a2.4 2.4 0 0 0-.815-.775zm.874 1.283v.003l-.001.01-.008.034a1 1 0 0 1-.038.11q-.054.137-.157.324c-.135.248-.318.538-.504.817a24 24 0 0 1-.679.967l-.047.063-.012.017-.003.004-.001.001.2.15.2.15v-.001l.001-.001.004-.004.012-.018.049-.065a30 30 0 0 0 .692-.986 12 12 0 0 0 .527-.855c.073-.133.137-.262.183-.377a1 1 0 0 0 .082-.343zm-1.5 2.5v.5h.5v-.5z"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeWidth: 0.5,
    d: "m851 133.828-6 14-18.5-1.5m65-39.5s-4.113 7.148-8.5 9.5c-2.177 1.167-6 2-6 2m13.999-24.5c.501 2-3.501 2-2 3s2 2.5 2 2.5"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#a)",
    d: "M783.175 60.978c-12.872 19.253 18.872 24.21 6 43.464L1106 50.592s-9.58-21.795-19.83-30.115c-19.66-15.965-40.24 16.196-62 5.5-11.02-5.42-24.715-11.052-35.535-17.105-26.485-14.815-33.589 3.264-62.46 2.025-21.007-.901-47.263-16.005-63.94 0-11.597 11.132-14.762 21.29-26.56 32.08-13.005 11.895-39.628-1.253-52.5 18"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeWidth: 0.5,
    d: "m810 151-5.5-2.5m4.639 6.362L795 157.555"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    d: "m920.5 180.996.993-141"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    fill: "#E3642A",
    d: "M959.872 39.005C941.809 17.073 922 42.865 922 42.865V93s20.384-19.705 35.38-19.283c11.57.326 16.465 10.62 27.906 12.856 23.004 4.494 34.554-19.759 57.804-18.64 10.65.512 26.91 5.784 26.91 5.784l-19.93-23.781 15.94-16.07s-13.89-3.603-22.92-3.856c-23.36-.653-66.275 29.567-83.218 8.995"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    fill: "#3B5AFF",
    fillOpacity: 0.8,
    d: "m974.317 89.135-.293 3.987-3.157-1.966z"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    fill: "#0931FF",
    fillOpacity: 0.8,
    d: "m866.146 76.06 2.03 5.665-3.718.111z"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    fill: "#FF0909",
    fillOpacity: 0.8,
    d: "m849.18 61.525 2.768-.374-2.081 3.082zm46.179 4.372-3.953-2.153 5.589-2.04z"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    fill: "#3B5AFF",
    d: "m912.213 113.698-3.864 2.309 1.086-5.85z"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    fill: "#FF0909",
    fillOpacity: 0.8,
    d: "m939.771 96.405-3.953-2.153 5.59-2.04z"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    stroke: "#C7B700",
    d: "M872.5 62.5 870 60m27.5 21-.5 3.5M846 78l-3.5 3.5m117 23.5v4m0-24.5-5 3.5M908 90.5l2.5 4.5"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    stroke: "var(--text-primary)",
    d: "M574.545 230.101s66.001 9.5 91.066-10.503c20.503-16.362 34.934-76.503 0-80.853-15.581-1.94-30.066 7.732-30.065 23.354 0 29.995 40.587 21.18 60.999 7.999 15.495-10.006 28.479-49.493 28.479-49.493m0 0-13.393 4.089m13.393-4.089 4.582 15.005"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: 930.979,
    x2: 932.535,
    y1: 4.753,
    y2: 101.898,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "var(--curriculum-bg-color)"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "var(--curriculum-bg-color)",
    stopOpacity: 0.567
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "var(--curriculum-bg-color)",
    stopOpacity: 0.289
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "var(--curriculum-bg-color)",
    stopOpacity: 0
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgCurriculumLandingStairway2);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/curriculum-landing-stairway-2.4a3c9aaee3820dbc2f0bf1ed8466764d.svg";